import { useEffect } from 'react';
import window from 'global/window';
import _ from 'lodash';

import { useStores } from 'src/hooks/use-stores';
import { hideZendeskWidget, closeZendeskWidget, showDecagonWidget } from 'shared/helpers/tools';
import { fetchDecagonUserAuth } from 'shared/helpers/decagon';

export default function useAdminChatWidget() {
  const { User, apolloClient } = useStores();

  useEffect(() => {
    closeZendeskWidget();
    hideZendeskWidget();
    return initializeDecagon(User, apolloClient);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

function initializeDecagon(User, apolloClient) {
  // Skip Decagon in E2E test environments - the widget's high z-index (99999999)
  // interferes with MUI modals during Playwright tests
  if (typeof window !== 'undefined' && window.__PLAYWRIGHT_TEST__) {
    return _.noop;
  }

  if (!window.duet) {
    const decagonInitScript = document.createElement(`script`);
    decagonInitScript.id = `chat-loader`;
    decagonInitScript.src = `https://decagon.ai/loaders/dutchie.js`;
    decagonInitScript.async = true;
    decagonInitScript.onload = async () => {
      // Decagon establishes the conversation the moment setUserId fires, so the signed
      // (signature, epoch) must be applied in the same turn — otherwise the conversation
      // is tagged _decagon_has_valid_signature:false and never recovers. Lower envs
      // without the HMAC secret return nulls and we fall through to unsigned.
      const auth = await fetchDecagonUserAuth(apolloClient);

      window.duet.setUserId(User.id);
      if (auth?.signature && typeof auth.epoch === 'number') {
        window.duet.setUserIdAuth(auth.signature, auth.epoch);
      }

      window.duet.setMetadata({
        email: User.email,
        name: User.fullName,
        userType: 'admin',
      });
    };
    document.body.appendChild(decagonInitScript);
  }

  // make sure it's not hidden from before
  showDecagonWidget();

  return () => window.duet?.hide();
}
